import * as TYPES from './medical-notes-actiontypes';
import { filter } from './medical-notes-filter-mapper';

const DEFAULT_DATE_FILTER = 'All';

export const initialState = {
  isNotReviewedByPatientCount: 0,
  notes: [],
  selectedMedicalNoteId: null,
  totalNumberOfPages: 1,
  currentPageNumber: 1,
  currentPageUrl: '',
  filter: {
    date: null,
    documentType: '',
    authoredBy: '',
  },
};

export const getDefaultFilter = () => (
  {
    date: DEFAULT_DATE_FILTER,
    documentType: initialState.filter.documentType,
    authoredBy: initialState.filter.authoredBy,
  }
);

export const medicalNotesReducer = (state = initialState, action) => {
  let newState;
  switch (action.type) {
    case TYPES.MEDICAL_NOTES_LOADED_SUCCESS: {
      let dateFilter = (state.filter.date === null && action.userPreferenceDateFilter)
        ? action.userPreferenceDateFilter
        : state.filter.date;
      dateFilter = dateFilter || DEFAULT_DATE_FILTER;
      const filterOptions = { ...state.filter, date: dateFilter };

      newState = { ...state,
        notes: filter(action.notes, filterOptions),
        filter: filterOptions };
      break;
    }
    case TYPES.MEDICAL_NOTES_COUNT_LOADED_SUCCESS:
      newState = { ...state, isNotReviewedByPatientCount: action.isNotReviewedByPatientCount };
      break;
    case TYPES.MEDICAL_NOTES_FILTER_OPTIONS_CHANGED:
      newState = {

        ...state,
        selectedMedicalNoteId: null,
        filter: { ...state.filter, ...action.filter },
        notes: filter(state.notes, action.filter),
      };
      break;
    case TYPES.MEDICAL_NOTES_TOGGLE_FILTER_PANEL:
      newState = { ...state, showFilterPanel: action.showFilterPanel };
      break;
    case TYPES.MEDICAL_NOTE_SET_REVIEWED_SUCCESS:
    {
      const notes = state.notes.map(
        (note) => {
          const newNote = note;
          newNote.isReviewedByPatient = note.ptMedicalNoteId === action.selectedMedicalNoteId ?
            true :
            note.isReviewedByPatient;
          return newNote;
        }
      );
      newState = { ...state, selectedMedicalNoteId: action.selectedMedicalNoteId, notes };
      break;
    }
    case TYPES.MEDICAL_NOTES_SELECTED_CHANGED:
      newState = { ...state, selectedMedicalNoteId: action.selectedMedicalNoteId };
      break;
    case TYPES.MEDICAL_NOTES_SET_TOTAL_NUMBER_OF_PAGES:
    {
      newState = { ...state, totalNumberOfPages: action.totalNumberOfPages };
      break;
    }
    case TYPES.MEDICAL_NOTES_SET_CURRENT_PAGE_NUMBER:
    {
      newState = { ...state, currentPageNumber: action.currentPageNumber };
      break;
    }
    case TYPES.MEDICAL_NOTES_SET_CURRENT_PAGE_URL:
    {
      newState = { ...state, currentPageUrl: action.currentPageUrl };
      break;
    }
    default:
      newState = state;
      break;
  }

  return newState;
};

export default medicalNotesReducer;
